import { Action, createReducer, on } from '@ngrx/store';
import {
    loadAssignedDocumentsFailure,
    loadAssignedDocumentsSuccess,
    loadDocumentContractHistoryFailure,
    loadDocumentContractHistorySuccess,
    loadDocumentNotesFailure,
    loadDocumentNotesSuccess,
    loadPendingDocumentsFailure,
    loadPendingDocumentsSuccess,
    setAssignedUploaderId,
    setCandidateId,
    setExpireDate,
    setIsCandidateUpload,
    setIsSignedContract
} from 'src/app/compliance/store/actions/document-batch-details.actions';
import { DocumentBatchDetailsState } from 'src/app/compliance/store/state/document-batch-details.state';
import { AssignedDocument } from '../../models/posted-documents-models';

const initialState: DocumentBatchDetailsState = {
    candidateId: 0,
    assignedUploaderId: 0,
    isSignedContract: false,
    isCandidateUpload: false,
    allReviewed: false,
    pendingDocuments: [],
    assignedDocuments: [],
    contractHistory: [],
    documentNotes: []
};

const reducer = createReducer(
    initialState,

    on(loadPendingDocumentsSuccess, (state, action) => ({
        ...state,
        pendingDocuments: action.pendingDocs
    })),

    on(loadPendingDocumentsFailure, (state, action) => ({
        ...state,
        pendingDocuments: []
    })),

    on(loadAssignedDocumentsSuccess, (state, action) => ({
        ...state,
        assignedDocuments: action.assignedDocs
    })),

    on(loadAssignedDocumentsFailure, (state, action) => ({
        ...state,
        assignedDocuments: []
    })),

    on(loadDocumentNotesSuccess, (state, action) => ({
        ...state,
        documentNotes: action.notes
    })),

    on(loadDocumentNotesFailure, (state, action) => ({
        ...state,
        documentNotes: []
    })),

    on(loadDocumentContractHistorySuccess, (state, action) => ({
        ...state,
        contractHistory: action.contracts
    })),

    on(loadDocumentContractHistoryFailure, (state, action) => ({
        ...state,
        contractHistory: []
    })),

    on(setCandidateId, (state, action) => ({
        ...state,
        candidateId: action.candidateId
    })),

    on(setAssignedUploaderId, (state, action) => ({
        ...state,
        assignedUploaderId: action.assignedUploaderId
    })),

    on(setIsSignedContract, (state, action) => ({
        ...state,
        isSignedContract: action.isSignedContract
    })),

    on(setIsCandidateUpload, (state, action) => ({
        ...state,
        isCandidateUpload: action.isCandidateUpload
    })),

    on(setExpireDate, (state, action) => ({
        ...state,
        assignedDocuments: state.assignedDocuments.map((doc: AssignedDocument) =>
            doc.requirementId === action.requirementId ? { ...doc, expires: action.expires } : doc
        )
    }))
);

export function documentBatchDetailsReducer(state: DocumentBatchDetailsState | undefined, action: Action) {
    return reducer(state, action);
}
